import { render, staticRenderFns } from "./pricelisthelp.vue?vue&type=template&id=738d1138&"
import script from "./pricelisthelp.vue?vue&type=script&lang=js&"
export * from "./pricelisthelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('738d1138')) {
      api.createRecord('738d1138', component.options)
    } else {
      api.reload('738d1138', component.options)
    }
    module.hot.accept("./pricelisthelp.vue?vue&type=template&id=738d1138&", function () {
      api.rerender('738d1138', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2nRyPRVnqk2kE/JS/pricelisthelp.vue"
export default component.exports